import { MetaFileLink } from 'src/app/models/metaFileLink.model';
import { HoldingFileType } from 'src/app/shared/enums/HoldingFileType.enum';

export class HoldingFileReqRes {
  public id: number;
  public fileType: HoldingFileType = HoldingFileType.MarketingDeck;
  public metaFileLinkId: number;
  public metaFileLink: MetaFileLink;
  constructor() {}
}
